// Debug utility for controlling console output based on URL parameter
// Usage: Add ?debug=true to the URL to enable debug messages

// Check if debug mode is enabled
const urlParams = new URLSearchParams(window.location.search);
const isDebugMode = urlParams.get('debug') === 'true';

// Export debug wrapper functions
export const debug = {
  log: (...args: any[]) => {
    if (isDebugMode) {
      console.log(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isDebugMode) {
      console.warn(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (isDebugMode) {
      console.error(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDebugMode) {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (isDebugMode) {
      console.debug(...args);
    }
  },
  
  isEnabled: () => isDebugMode
};

// Export for backward compatibility if needed
export const isDebugEnabled = () => isDebugMode;